import * as React from 'react';
import strings from 'owa-strings/owa-extensibility-strings';
import { AddinIcons, ControlIcons } from 'owa-addins-icons';
import { format } from 'owa-strings';
import { IconButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('./TaskPaneHeader.scss');

export interface PersistButtonProps {
    displayName: string;
    isPersisted: boolean;
    togglePersist: () => void;
}

export default class PersistButton extends React.Component<PersistButtonProps, any> {
    render() {
        const icon = this.getPersistButtonIcon();
        const buttonText = this.getPersistButtonText();
        return (
            <IconButton
                className={styles.persistIcon}
                onClick={this.props.togglePersist}
                title={buttonText}
                ariaLabel={buttonText}
                iconProps={{ iconName: icon }}
            />
        );
    }

    public getPersistButtonText(): string {
        const text = this.props.isPersisted
            ? strings.taskPaneUnpinButtonLabel
            : strings.taskPanePinButtonLabel;
        return format(text, this.props.displayName);
    }

    public getPersistButtonIcon(): string {
        return this.props.isPersisted ? ControlIcons.Pinned : AddinIcons.Pin;
    }
}
